import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconMailOpened = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M14.66 5.333c0-.48-.246-.9-.626-1.133L8.001.667 1.967 4.2c-.38.233-.633.653-.633 1.133V12c0 .733.6 1.333 1.333 1.333h10.667c.733 0 1.333-.6 1.333-1.333l-.006-6.667zM8 8.667l-5.506-3.44L8.001 2l5.506 3.227-5.506 3.44z"
	})
});
export default SvgIconMailOpened;
